export default __webpack_public_path__ + "static/media/streamer_avatar19.cbc4b54c.png";